import service from '../utils/request'

// 配置
export function website(data) {
    return service.request({
        method: 'get',
        url: '/plugin.website.website/website',
        params: data
    })
}

// 最新资讯
export function latestNews() {
    return service.request({
        method: 'get',
        url: '/plugin.website.website/getNews'
    })
}

// 分类列表
export function categoryList() {
    return service.request({
        method: 'get',
        url: '/plugin.website.website/category'
    })
}

// 文章列表
export function articleList(data) {
    return service.request({
        method: 'post',
        url: '/plugin.website.website/index',
        params: data
    })
}

// 文章详情
export function articleDetail(data) {
    return service.request({
        method: 'get',
        url: '/plugin.website.website/detail',
        params: data
    })
}

// 预约回电
export function reservationCall(data) {
    return service.request({
        method: 'post',
        url: '/plugin.website.website/reservation',
        params: data
    })
}

// 预约演示
export function reservationDemo(data) {
    return service.request({
        method: 'post',
        url: '/plugin.website.website/demonstrate',
        params: data
    })
}

// 更新记录
export function logList(data) {
    return service.request({
        method: 'post',
        url: '/plugin.website.website/log',
        params: data
    })
}

// 下载
export function downloadUrl(data) {
    return service.request({
        method: 'post',
        url: '/plugin.website.website/download',
        params: data
    })
}

// 首页轮播图
export function bannerList() {
    return service.request({
        method: 'get',
        url: '/plugin.website.website/getBanner'
    })
}


// 合作伙伴
export function brandList() {
    return service.request({
        method: 'get',
        url: '/plugin.website.website/getBrandList'
    })
}
// 产品分类
export function goodsCategoryList() {
    return service.request({
        method: 'get',
        url: '/goods.category/index'
    })
}

// 产品列表
export function goodsList(data) {
    return service.request({
        method: 'get',
        url: '/goods.goods/lists',
        params: data
    })
}

// 产品详情
export function goodsDetail(data) {
    return service.request({
        method: 'get',
        url: '/goods.goods/detail',
        params: data
    })
}

// 公司历程
export function matterList() {
    return service.request({
        method: 'get',
        url: '/plugin.website.website/matter'
    })
}

// 反馈
export function feed(data) {
    return service.request({
        method: 'post',
        url: '/plugin.website.website/feedback',
        params: data
    })
}

// 产品详情
export function goodsQrcode(data) {
    return service.request({
        method: 'get',
        url: '/plugin.website.website/getGoodsQrcode',
        params: data
    })
}
